export default __webpack_public_path__ + "static/FTRegolaNeue-Light-b0d28c800af76baad7802f30cb77438e.woff2";